import { render, staticRenderFns } from "./ViewpointCollection.vue?vue&type=template&id=1a318432&"
import script from "./ViewpointCollection.vue?vue&type=script&lang=js&"
export * from "./ViewpointCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports